/**
 * One recording at a time, app-wide: a voice note (useVoiceRecording), chat
 * dictation and a visit recording (services/visitRecorder) all use the one
 * microphone. Whoever records holds this; another start is refused while the
 * holder says it is busy (starting, recording, paused or finishing).
 */
type Holder = { owner: object; busy: () => boolean };

let holder: Holder | null = null;

/** True while anything in the app is starting, recording or finishing a recording. */
export function isRecordingActive(): boolean {
  return !!holder?.busy();
}

/** Someone other than this owner is recording now. */
export function recordingHeldByOther(owner: object): boolean {
  return !!holder && holder.owner !== owner && holder.busy();
}

export function claimRecordingLock(owner: object, busy: () => boolean): void {
  holder = { owner, busy };
}

export function releaseRecordingLock(owner: object): void {
  if (holder?.owner === owner) holder = null;
}

/** For tests only. */
export function resetRecordingLock(): void {
  holder = null;
}
